import arrayReduce from 'fast-loops/lib/arrayReduce';

export default function sortObjectKeys(input) {
  var keys = Object.keys(input);
  var sortedKeys = keys.sort(function (a, b) {
    return a.localeCompare(b);
  });

  return arrayReduce(sortedKeys, function (output, key) {
    output[key] = input[key];

    return output;
  }, {});
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/@cloudflare/style-container/node_modules/fela/es/sortObjectKeys.js
// module id = 1097
// module chunks = 0